(() => {
  const DEFAULT_CONFIG = {
    enabled:true,
    layout:{desktop_position:'right',tablet_position:'right',mobile_position:'bottom',desktop_width_type:'px',desktop_width:470,desktop_min_width:360,desktop_max_width:560,tablet_width:72,mobile_width:100,mobile_height:92,mobile_fullscreen:false},
    appearance:{preset:'ebprime',background:'#ffffff',surface:'#f7f9fc',text:'#10233f',muted:'#697386',cta:'#082c63',cta_hover:'#0d3c82',border:'#dfe5ee',accent:'#c7922e',success:'#1f8b5c',progress_background:'#eee5d2',progress_fill:'#082c63',radius:8,shadow:true,density:'comfortable',image_size:84,font_size:14},
    texts:{title:'Cosul tau',empty_title:'Cosul tau este gol',empty_text:'Alege produsele potrivite si continua cumparaturile.',continue:'Continua cumparaturile',checkout:'Finalizeaza comanda',view_cart:'Vezi cosul',remove:'Elimina',quantity:'Cantitate',size:'Marime',color:'Culoare',subtotal:'Subtotal',savings:'Economisesti',shipping_cost:'Livrare',shipping_free:'Livrare gratuita',shipping_calculated:'Se calculeaza la checkout',free_before:'Mai adauga {remaining} pentru livrare gratuita',free_after:'Ai obtinut livrare gratuita!',recommendations_title:'Seturi recomandate',offer_title:'Oferta recomandata',add:'Adauga',added:'Produs adaugat',error:'Nu am putut actualiza cosul. Incearca din nou.',stock:'Stoc insuficient',coupon_label:'Cod promotional',coupon_placeholder:'Introdu codul',coupon_apply:'Aplica',coupon_ready:'Codul va fi aplicat la finalizarea comenzii.'},
    shipping:{enabled:false,threshold:0,cost:0,currency:'RON',calculate_after_discount:true,position:'top',excluded_handles:[]},
    brochure:{enabled:true,title:'Primești gratuit broșura electronică Qualuca',subtitle:'Bonus inclus în comanda ta',image:'/cdn/shop/files/brosura-electronica-gratuita-qualuca-ceai-de-slabit-detox-capsule-slabit-desktop.webp?width=120',image_id:'',collections:[],resolved_product_ids:[]},
    delivery:{enabled:true,title:'Livrare',default_method:'standard',standard_label:'Livrare standard',standard_description:'Livrare la adresa',easybox_enabled:true,easybox_label:'Livrare la Easybox',easybox_description:'Ridicare din lockerul ales',easybox_price_mode:'fixed',easybox_cost:16.95,choose_locker:'Alege easybox-ul',change_locker:'Schimba easybox-ul',locker_selected:'Easybox selectat',locker_required:'Alege un easybox pentru a continua.',sdk_not_configured:'Selectorul Easybox nu este disponibil momentan.',easybox_checkout_fallback:'Vei alege lockerul Easybox la checkout.',client_id:'',api_username:'',country_code:'RO',lang_code:'ro',theme:'light',show_pudos:false},
    recommendations:{enabled:true,source:'bestseller',layout_desktop:'slider',layout_mobile:'slider',max_desktop:8,max_mobile:8,hide_products_in_cart:true,items:[]},
    offers:{enabled:false,items:[]},
    summary:{show_accelerated_checkout:true,show_savings:true,show_trust:true,show_coupon:true},
    empty_cart:{cta_link:'/collections/all',show_recommendations:true},
    tracking:{enabled:true},
    rewards:{
      enabled:false,campaign_id:'qualuca-cart-rewards',title:'Cadourile tale Qualuca',description:'Recompensele se cumuleaza.',cumulative:true,
      show_drawer:true,show_cart_page:true,empty_text:'Adauga produse pentru a incepe sa deblochezi cadouri.',all_unlocked_text:'Felicitari! Ai deblocat toate recompensele.',
      exclude_gifts:true,excluded_product_ids:[],excluded_collection_ids:[],tiers:[],
      appearance:{background:'#fffaf1',progress:'#0b356f',unlocked:'#1f8b5c',locked:'#c7ced8',text:'#10233f',button:'#082c63',radius:8,spacing:12,icon_size:22},
      texts:{below_first:'Mai adauga {{amount}} pentru a primi un produs cadou.',first_unlocked:'Ai deblocat primul cadou!',below_second:'Mai adauga {{amount}} pentru a primi inca un produs cadou.',second_unlocked:'Ai deblocat doua cadouri!',shipping_before:'Mai adauga {{amount}} pentru livrare gratuita.',all_unlocked:'Felicitari! Ai deblocat toate recompensele.',choose_gift:'Alege cadoul',change_gift:'Schimba cadoul',remove_gift:'Elimina',gift_badge:'CADOU',gift_modal_title:'Alege produsul cadou',choose_free:'Alege gratuit',unlocked_label:'Deblocat',locked_label:'Blocat'}
    }
  };

  const deepMerge = (base, override) => {
    const result = { ...base };
    Object.keys(override || {}).forEach(key => {
      const value = override[key];
      result[key] = value && typeof value === 'object' && !Array.isArray(value) && base[key] && typeof base[key] === 'object'
        ? deepMerge(base[key], value)
        : value;
    });
    return result;
  };
  const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const rootPath = () => window.Shopify?.routes?.root || '/';
  const eventElement = event => {
    const target = event?.target;
    if (target && typeof target.closest === 'function') return target;
    return target?.parentElement && typeof target.parentElement.closest === 'function' ? target.parentElement : null;
  };

  class EbPrimeCartDrawer {
    constructor(dialog) {
      this.dialog = dialog;
      this.panel = dialog.querySelector('[data-ebpcart-panel]');
      this.body = dialog.querySelector('[data-ebpcart-body]');
      this.itemsNode = dialog.querySelector('[data-ebpcart-items]');
      this.emptyNode = dialog.querySelector('[data-ebpcart-empty]');
      this.footer = dialog.querySelector('[data-ebpcart-footer]');
      this.shippingNode = dialog.querySelector('[data-ebpcart-shipping]');
      this.deliveryNode = dialog.querySelector('[data-ebpcart-delivery]');
      this.deliveryDetails = dialog.querySelector('[data-ebpcart-delivery-details]');
      this.deliveryStatus = dialog.querySelector('[data-ebpcart-easybox-status]');
      this.samedaySdkPromise = null;
      this.samedayPlugin = null;
      this.samedaySubscribed = false;
      this.easyboxReturnToCart = false;
      this.deliveryBusy = false;
      this.statusNode = dialog.querySelector('[data-ebpcart-status]');
      this.offersNode = dialog.querySelector('[data-ebpcart-offers]');
      this.recommendationsNode = dialog.querySelector('[data-ebpcart-recommendations]');
      this.recommendationTrack = dialog.querySelector('[data-ebpcart-recommendation-track]');
      this.rewardsDrawer = dialog.querySelector('[data-ebpc-rewards-drawer]');
      this.ebookNode = dialog.querySelector('[data-ebpcart-ebook]');
      this.rewardsPage = document.querySelector('[data-ebpc-rewards-page]');
      this.rewardPicker = document.querySelector('[data-ebpc-reward-picker]');
      this.rewardPickerBody = this.rewardPicker?.querySelector('[data-ebpc-reward-picker-body]');
      this.rewardSlot = null;
      this.rewardSyncPromise = null;
      this.rewardBusy = false;
      this.rewardUnlockedSeen = new Set();
      this.rewardActionNodes = new WeakSet();
      this.handleRewardAction = null;
      this.rewardRenderTimers = [];
      this.configEndpoint = dialog.dataset.configEndpoint;
      this.config = deepMerge(DEFAULT_CONFIG, {});
      this.cart = null;
      this.lastTrigger = null;
      this.productCache = new Map();
      this.itemMeta = new Map();
      this.reviewSummaries = {};
      this.reviewPageCache = new Map();
      this.enrichmentToken = 0;
      this.discountCode = '';
      try { this.discountCode = sessionStorage.getItem('qualuca-cart-discount') || ''; } catch (_) {}
      this.reviewSummariesPromise = this.loadReviewSummaries();
      this.thresholdWasReached = false;
      this.openedAt = 0;
      this.sessionHash = this.getSessionHash();
      this.configPromise = this.loadConfig();
      this.bind();
      this.configPromise.then(() => { if (this.rewardsPage) this.refreshCart(false); });
    }

    bind() {
      document.addEventListener('click', event => {
        const target = eventElement(event);
        if (!target) return;
        const trigger = target.closest('[data-ebprime-cart-trigger],[data-testid="cart-drawer-trigger"],a[href="/cart"]');
        if (trigger) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.open(trigger);
        }
      }, true);

      this.handleRewardAction = event => {
        const target = eventElement(event);
        if (!target) return;
        const choose = target.closest('[data-ebpc-reward-choose],[data-ebpc-reward-change]');
        if (choose) {
          event.preventDefault();
          this.openRewardPicker(choose.dataset.slotId || '', choose.dataset.tierId || '');
          return;
        }
        const removeGift = target.closest('[data-ebpc-reward-remove]');
        if (removeGift) {
          event.preventDefault();
          this.removeRewardGift(removeGift.dataset.slotId || '');
          return;
        }
        if (target.closest('[data-ebpc-reward-picker-close]')) {
          event.preventDefault();
          this.closeRewardPicker();
          return;
        }
        const addGift = target.closest('[data-ebpc-reward-add]');
        if (addGift) {
          event.preventDefault();
          this.addRewardGift(addGift);
        }
      };
      this.syncRewardNodes();

      this.rewardObserver = new MutationObserver(() => {
        if (!this.syncRewardNodes() || !this.cart) return;
        this.scheduleRewardRender();
      });
      this.rewardObserver.observe(document.body, { childList:true, subtree:true });

      this.rewardPicker?.addEventListener('cancel', event => {
        event.preventDefault();
        this.closeRewardPicker();
      });
      this.rewardPicker?.addEventListener('click', event => {
        if (event.target === this.rewardPicker) this.closeRewardPicker();
      });
      this.rewardPicker?.addEventListener('keydown', event => this.trapRewardPickerFocus(event));
      this.dialog.addEventListener('click', event => {
        const target = eventElement(event);
        if (!target) return;
        if (target === this.dialog || target.closest('[data-ebpcart-close]')) return this.close();
        const quantity = target.closest('[data-ebpcart-quantity]');
        if (quantity) {
          const item = quantity.closest('[data-ebpcart-item]');
          const current = Number(item?.dataset.quantity || 0);
          const action = quantity.dataset.ebpcartQuantity;
          const next = action === 'increase' ? current + 1 : Math.max(0, current - 1);
          this.updateLine(item, next, action === 'increase' ? 'quantity_increased' : 'quantity_decreased');
          return;
        }
        const remove = target.closest('[data-ebpcart-remove]');
        if (remove) return this.updateLine(remove.closest('[data-ebpcart-item]'), 0, 'item_removed');
        const deliveryMethod = target.closest('[data-ebpcart-delivery-method]');
        if (deliveryMethod) {
          event.preventDefault();
          this.selectDeliveryMethod(deliveryMethod.dataset.ebpcartDeliveryMethod || 'standard');
          return;
        }
        const lockerChoose = target.closest('[data-ebpcart-easybox-choose]');
        if (lockerChoose) {
          event.preventDefault();
          this.openEasyboxPicker();
          return;
        }
        const add = target.closest('[data-ebpcart-recommendation-add]');
        if (add) return this.addRecommendation(add);
        const productLink = target.closest('[data-ebpcart-recommendation-link]');
        if (productLink) this.track('recommendation_clicked', { handle:productLink.dataset.handle || '' });
        const offerLink = target.closest('[data-ebpcart-offer-link]');
        if (offerLink) this.track('upsell_accepted', { offer_id:offerLink.dataset.offerId || '' });
        const walletButton = target.closest('shopify-accelerated-checkout-cart, shopify-apple-pay-button, shopify-google-pay-button');
        if (walletButton) this.track('checkout_clicked', {
          item_count:this.cart?.item_count || 0,
          wallet:'accelerated_checkout'
        });
      });

      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); });
      this.dialog.addEventListener('close', () => this.restoreFocus());
      this.dialog.querySelector('[data-ebpcart-checkout]')?.addEventListener('click', event => this.handleCheckout(event));
      this.dialog.querySelector('[data-ebpcart-coupon]')?.addEventListener('submit', event => {
        event.preventDefault();
        const input = event.currentTarget.querySelector('input');
        const code = input?.value.trim();
        if (!code) return;
        this.discountCode = code;
        try { sessionStorage.setItem('qualuca-cart-discount', code); } catch (_) {}
        const status = this.dialog.querySelector('[data-ebpcart-coupon-status]');
        if (status) status.textContent = this.config.texts.coupon_ready;
        this.track('coupon_applied', { code_length:code.length });
      });

      document.addEventListener('shopify:cart:lines-update', event => {
        if (event.qualucaCartSource) return;
        Promise.resolve(event.promise).catch(() => null).finally(() => this.refreshCart(true));
      });
      // Horizon product forms emit cart:update, independently of the Ajax cart bridge.
      document.addEventListener('cart:update', event => {
        const data = event.detail?.data;
        if (event.qualucaCartSource || data?.source !== 'product-form-component' || data.didError) return;
        this.refreshCart(true);
      });
      document.addEventListener('cart:refresh', () => this.refreshCart(true, true));
      window.addEventListener('resize', () => this.applyResponsiveConfig(), { passive:true });
    }

    syncRewardNodes() {
      let changed = false;
      const drawer = this.dialog.querySelector('[data-ebpc-rewards-drawer]');
      const page = document.querySelector('[data-ebpc-rewards-page]');
      const picker = document.querySelector('[data-ebpc-reward-picker]');
      if (drawer && drawer !== this.rewardsDrawer) { this.rewardsDrawer = drawer; changed = true; }
      if (page && page !== this.rewardsPage) { this.rewardsPage = page; changed = true; }
      if (picker && picker !== this.rewardPicker) {
        this.rewardPicker = picker;
        this.rewardPickerBody = picker.querySelector('[data-ebpc-reward-picker-body]');
        changed = true;
      }
      [this.rewardsDrawer, this.rewardsPage, this.rewardPicker].forEach(node => {
        if (!node || this.rewardActionNodes.has(node) || !this.handleRewardAction) return;
        node.addEventListener('click', this.handleRewardAction);
        this.rewardActionNodes.add(node);
      });
      return changed;
    }

    scheduleRewardRender() {
      this.rewardRenderTimers.forEach(timer => window.clearTimeout(timer));
      this.rewardRenderTimers = [0, 80, 250].map(delay => window.setTimeout(() => {
        if (!this.cart) return;
        this.syncRewardNodes();
        this.renderRewards();
      }, delay));
    }

    async loadConfig() {
      const cacheKey = 'qualuca-cart-config-v3';
      let cached = null;
      try { cached = JSON.parse(localStorage.getItem(cacheKey) || 'null'); } catch (_) {}
      if (cached?.config && Date.now() - Number(cached.savedAt || 0) < 15000) {
        this.config = deepMerge(DEFAULT_CONFIG, cached.config);
        this.applyConfig();
      }
      try {
        const response = await fetch(`${this.configEndpoint}${this.configEndpoint.includes('?') ? '&' : '?'}_=${Date.now()}`, { mode:'cors', credentials:'omit', cache:'no-store', headers:{ Accept:'application/json' } });
        if (!response.ok) throw new Error('Config endpoint unavailable');
        const payload = await response.json();
        if (!payload.ok || !payload.config) throw new Error('Invalid cart config');
        this.config = deepMerge(DEFAULT_CONFIG, payload.config);
        localStorage.setItem(cacheKey, JSON.stringify({ savedAt:Date.now(), version:payload.version, config:this.config }));
      } catch (error) {
        if (!cached?.config) this.config = deepMerge(DEFAULT_CONFIG, {});
        console.warn('[Qualuca cart] Using cached/default config.', error);
      }
      this.applyConfig();
      return this.config;
    }

    applyConfig() {
      this.config.summary.show_coupon = false;
      const a = this.config.appearance;
      const vars = {
        '--ebpc-bg':a.background,'--ebpc-surface':a.surface,'--ebpc-text':a.text,'--ebpc-muted':a.muted,
        '--ebpc-cta':a.cta,'--ebpc-cta-hover':a.cta_hover,'--ebpc-border':a.border,'--ebpc-accent':a.accent,
        '--ebpc-success':a.success,'--ebpc-progress-bg':a.progress_background,'--ebpc-progress':a.progress_fill,
        '--ebpc-radius':`${a.radius}px`,'--ebpc-font-size':`${a.font_size}px`,'--ebpc-image-size':`${a.image_size}px`,
        '--ebpc-min-width':`${this.config.layout.desktop_min_width}px`,'--ebpc-max-width':`${this.config.layout.desktop_max_width}px`,
        '--ebpc-tablet-width':`${this.config.layout.tablet_width}vw`,'--ebpc-mobile-width':`${this.config.layout.mobile_width}%`,
        '--ebpc-mobile-height':`${this.config.layout.mobile_height}%`
      };
      const widthUnit = this.config.layout.desktop_width_type === 'percent' ? '%' : 'px';
      vars['--ebpc-width'] = `${this.config.layout.desktop_width}${widthUnit}`;
      Object.entries(vars).forEach(([key, value]) => this.dialog.style.setProperty(key, value));
      this.dialog.dataset.density = a.density;
      this.panel.style.boxShadow = a.shadow ? '' : 'none';
      this.dialog.querySelectorAll('[data-ebpcart-text]').forEach(node => {
        const key = node.dataset.ebpcartText;
        if (this.config.texts[key]) node.textContent = this.config.texts[key];
      });
      this.dialog.querySelector('[data-ebpcart-continue]').href = this.config.empty_cart.cta_link || '/collections/all';
      const wallets = this.dialog.querySelector('[data-ebpcart-wallets]');
      if (wallets) wallets.hidden = !this.config.summary.show_accelerated_checkout;
      this.configureWalletButtons();
      const trust = this.dialog.querySelector('[data-ebpcart-trust]');
      if (trust) trust.hidden = !this.config.summary.show_trust;
      const coupon = this.dialog.querySelector('[data-ebpcart-coupon]');
      if (coupon) coupon.hidden = true;
      this.placeShipping();
      this.renderDelivery();
      this.applyResponsiveConfig();
    }

    applyResponsiveConfig() {
      const width = window.innerWidth;
      let position;
      if (width < 750) position = this.config.layout.mobile_fullscreen ? 'fullscreen-mobile' : this.config.layout.mobile_position;
      else if (width < 990) position = this.config.layout.tablet_position;
      else position = this.config.layout.desktop_position;
      this.dialog.dataset.position = position || 'right';
      this.dialog.dataset.recLayout = width < 750 ? this.config.recommendations.layout_mobile : this.config.recommendations.layout_desktop;
      this.configureWalletButtons();
    }

    configureWalletButtons() {
      const wallets = this.dialog.querySelector('[data-ebpcart-wallets]');
      if (!wallets) return;
      const deliveryState = this.deliveryState();
      const lockerMissing = deliveryState.method === 'easybox' && deliveryState.easyboxPickerReady && !deliveryState.hasLocker;
      const officialCheckout = wallets.querySelector('shopify-accelerated-checkout-cart');
      wallets.hidden = !this.config.summary.show_accelerated_checkout || lockerMissing || !officialCheckout;
    }

    placeShipping() {
      const slot = this.dialog.querySelector('[data-ebpcart-progress-slot]');
      if (slot && this.shippingNode && this.shippingNode.parentNode !== slot) slot.prepend(this.shippingNode);
    }

    async open(trigger, useCurrentCart = false) {
      this.lastTrigger = trigger || document.activeElement;
      await this.configPromise;
      if (!this.config.enabled) {
        window.location.href = `${rootPath()}cart`;
        return;
      }
      if (!useCurrentCart || !this.cart) await this.refreshCart(false);
      if (!this.dialog.open) this.dialog.showModal();
      document.body.classList.add('ebpcart-open');
      this.openedAt = Date.now();
      this.track('cart_opened', { item_count:this.cart?.item_count || 0 });
      requestAnimationFrame(() => this.dialog.querySelector('[data-ebpcart-close]')?.focus());
      this.loadRecommendations();
    }

    close() {
      if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
      this.track('cart_closed', { open_ms:Math.max(0, Date.now() - this.openedAt) });
      this.dialog.classList.add('is-closing');
      window.setTimeout(() => {
        this.dialog.classList.remove('is-closing');
        this.dialog.close();
        document.body.classList.remove('ebpcart-open');
      }, 210);
    }

    restoreFocus() {
      document.body.classList.remove('ebpcart-open');
      if (this.lastTrigger instanceof HTMLElement) this.lastTrigger.focus({ preventScroll:true });
    }

    async fetchCart() {
      const response = await fetch(`${rootPath()}cart.js`, { headers:{ Accept:'application/json' }, credentials:'same-origin' });
      if (!response.ok) throw new Error(this.config.texts.error);
      return response.json();
    }

    async refreshCart(shouldOpen = false, publishUpdate = false) {
      try {
        this.cart = await this.fetchCart();
        await this.refreshRewardProgress(this.cart);
        this.renderCart();
        this.scheduleRewardRender();
        if (publishUpdate) this.publishCartUpdate('update', this.cart, 'ajax-cart', 0);
        if (shouldOpen && !this.dialog.open) await this.open(document.activeElement, true);
      } catch (error) {
        this.showStatus(error.message || this.config.texts.error, true);
        this.track('cart_error', { action:'refresh' });
      }
    }

    renderCart() {
      const cart = this.cart || { items:[], item_count:0, total_price:0 };
      const count = Number(cart.item_count || 0);
      this.syncHeaderCartCount(count);
      this.emptyNode.hidden = count > 0;
      this.itemsNode.hidden = count === 0;
      this.footer.hidden = count === 0;
      this.renderBrochure(cart);
      if (count > 0) {
        this.renderItems(cart.items || []);
        this.enrichCartItems(cart.items || []);
      } else {
        this.itemsNode.replaceChildren();
        this.itemMeta.clear();
      }
      this.renderShipping();
      this.renderRewards();
      this.renderDelivery();
      this.renderSummary();
      this.renderOffers();
      if (this.dialog.open) this.loadRecommendations();
    }

    renderBrochure(cart = this.cart) {
      if (!this.ebookNode) return;
      const brochure = this.config?.brochure || DEFAULT_CONFIG.brochure;
      const eligibleProductIds = new Set((brochure.resolved_product_ids || []).map(value => this.normalizeResourceId(value)));
      const eligible = brochure.enabled !== false && eligibleProductIds.size > 0 && (cart?.items || []).some(item => {
        if (this.isRewardGiftItem(item)) return false;
        return eligibleProductIds.has(this.normalizeResourceId(item.product_id));
      });
      this.ebookNode.hidden = !eligible;
      if (!eligible) return;
      const image = this.ebookNode.querySelector('[data-ebpcart-ebook-image]');
      const title = this.ebookNode.querySelector('[data-ebpcart-ebook-title]');
      const subtitle = this.ebookNode.querySelector('[data-ebpcart-ebook-subtitle]');
      if (title) title.textContent = brochure.title || DEFAULT_CONFIG.brochure.title;
      if (subtitle) {
        subtitle.textContent = brochure.subtitle || '';
        subtitle.hidden = !brochure.subtitle;
      }
      if (image) {
        const imageUrl = brochure.image || '';
        image.hidden = !imageUrl;
        if (imageUrl) {
          image.src = imageUrl;
          image.alt = brochure.title || 'Broșura Qualuca';
        }
      }
    }

    syncHeaderCartCount(count) {
      const drawerCount = this.dialog.querySelector('[data-ebpcart-count]');
      if (drawerCount) drawerCount.textContent = count === 1 ? '1 produs în coș' : `${count} produse în coș`;
      document.querySelectorAll('cart-icon').forEach(icon => {
        if (typeof icon.renderCartBubble === 'function') {
          icon.renderCartBubble(count);
          return;
        }
        const bubble = icon.querySelector('.cart-bubble');
        const countNode = icon.querySelector('.cart-bubble__text-count');
        if (countNode) {
          countNode.textContent = count > 0 && count < 100 ? String(count) : '';
          countNode.classList.toggle('hidden', count === 0);
        }
        bubble?.classList.toggle('visually-hidden', count === 0);
        icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      });
      try {
        sessionStorage.setItem('cart-count', JSON.stringify({ value:String(count), timestamp:Date.now() }));
      } catch (_) {}
    }
    async loadReviewSummaries() {
      const source = this.dialog.dataset.reviewSummariesUrl;
      if (!source) return;
      try {
        const response = await fetch(source, { headers:{ Accept:'application/json' }, credentials:'same-origin' });
        if (!response.ok) throw new Error('Review summaries unavailable');
        const payload = await response.json();
        this.reviewSummaries = payload.products || payload.families || {};
        if (this.cart?.items?.length) this.renderItems(this.cart.items);
      } catch (_) {
        this.reviewSummaries = {};
      }
    }

    familyForItem(item) {
      const value = [item?.product_type, item?.product_title, item?.title, item?.handle].filter(Boolean).join(' ').toLowerCase();
      if (/copii|kids/.test(value)) return 'kids';
      if (/scurt|short/.test(value)) return 'short';
      if (/clasic|classic/.test(value)) return 'classic';
      return '';
    }

    reviewMarkup(item) {
      const summary = this.reviewSummaries[item?.handle] || this.reviewSummaries[this.familyForItem(item)];
      if (!summary || !Number(summary.total_reviews)) return '';
      const rating = Number(summary.average || 0);
      const total = Number(summary.total_reviews || 0);
      const ratingText = rating.toLocaleString('ro-RO', { minimumFractionDigits:1, maximumFractionDigits:2 });
      return `<div class="ebpcart__item-rating" aria-label="${ratingText} din 5, ${total} recenzii"><span aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</span><strong>${ratingText}</strong><small>(${total})</small></div>`;
    }

    async fetchReviewSummary(handle) {
      if (!handle) return null;
      if (this.reviewPageCache.has(handle)) return this.reviewPageCache.get(handle);
      const pending = (async () => {
        try {
          const response = await fetch(`${rootPath()}products/${encodeURIComponent(handle)}`, { headers:{ Accept:'text/html' }, credentials:'same-origin' });
          if (!response.ok) return null;
          const documentHtml = new DOMParser().parseFromString(await response.text(), 'text/html');
          const badge = documentHtml.querySelector('.jdgm-prev-badge[data-average-rating][data-number-of-reviews]');
          const average = Number(badge?.dataset?.averageRating || 0);
          const total = Number(badge?.dataset?.numberOfReviews || 0);
          if (!average || !total) return null;
          const summary = { average, total_reviews:total };
          this.reviewSummaries[handle] = summary;
          return summary;
        } catch (_) { return null; }
      })();
      this.reviewPageCache.set(handle, pending);
      return pending;
    }

    async enrichCartItems(items) {
      const token = ++this.enrichmentToken;
      const rows = await Promise.all(items.map(async item => {
        const [product] = await Promise.all([this.fetchProduct(item.handle), this.fetchReviewSummary(item.handle)]);
        const variant = product?.variants?.find(row => String(row.id) === String(item.variant_id || item.id));
        return [String(item.key), {
          compareAtPrice:Number(variant?.compare_at_price || 0),
          productPrice:Number(variant?.price || item.original_price || item.final_price || 0)
        }];
      }));
      if (token !== this.enrichmentToken) return;
      this.itemMeta = new Map(rows);
      if (this.cart?.items?.length) {
        this.renderItems(this.cart.items);
        this.renderSummary();
      }
    }
    renderItems(items) {
      this.itemsNode.innerHTML = items.map(item => this.itemMarkup(item)).join('');
    }

    itemMarkup(item) {
      if (this.isRewardGiftItem(item)) return this.rewardGiftItemMarkup(item);
      const options = this.optionRows(item);
      const quantity = Math.max(1, Number(item.quantity || 1));
      const meta = this.itemMeta.get(String(item.key)) || {};
      const finalLine = Number(item.final_line_price || 0);
      const compareAtLine = Number(meta.compareAtPrice || 0) * quantity;
      const originalLine = Math.max(finalLine, Number(item.original_line_price || 0), compareAtLine);
      const discount = originalLine > finalLine && originalLine > 0 ? Math.round((1 - finalLine / originalLine) * 100) : 0;
      const image = item.image || item.featured_image?.url || '';
      const rating = this.reviewMarkup(item);
      return `<article class="ebpcart__item" data-ebpcart-item data-key="${encodeURIComponent(item.key)}" data-quantity="${Number(item.quantity || 0)}">
        <a class="ebpcart__item-image" href="${escapeHtml(item.url || '#')}"><img src="${escapeHtml(this.resizeImage(image, 220))}" alt="${escapeHtml(item.product_title || '')}" loading="eager" width="220" height="220"></a>
        <div class="ebpcart__item-body">
          <a class="ebpcart__item-title" href="${escapeHtml(item.url || '#')}">${escapeHtml(item.product_title || item.title || '')}</a>
          <div class="ebpcart__item-options">${options}</div>
          ${rating}
          <div class="ebpcart__item-controls">
            <div class="ebpcart__quantity" aria-label="${escapeHtml(this.config.texts.quantity)}">
              <button type="button" data-ebpcart-quantity="decrease" aria-label="Scade cantitatea">&minus;</button><span aria-live="polite">${Number(item.quantity || 0)}</span><button type="button" data-ebpcart-quantity="increase" aria-label="Creste cantitatea">+</button>
            </div>
            <button type="button" class="ebpcart__remove" data-ebpcart-remove aria-label="${escapeHtml(this.config.texts.remove)} ${escapeHtml(item.product_title || '')}"><svg viewBox="0 0 24 24"><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"></path></svg>${escapeHtml(this.config.texts.remove)}</button>
          </div>
        </div>
        <div class="ebpcart__item-price"><strong>${this.formatMoney(finalLine)}</strong>${originalLine > finalLine ? `<del>${this.formatMoney(originalLine)}</del>` : ''}${discount ? `<span class="ebpcart__item-discount">-${discount}%</span>` : ''}</div>
      </article>`;
    }
    rewardGiftItemMarkup(item) {
      const state = this.rewardState(this.cart);
      const slotId = String(item.properties?._eb_reward_slot_id || '');
      const slot = state.slots.find(candidate => candidate.id === slotId);
      const options = this.optionRows(item);
      const image = item.image || item.featured_image?.url || '';
      const originalLine = Math.max(Number(item.original_line_price || 0), Number(item.final_line_price || 0), Number(item.price || 0));
      return `<article class="ebpcart__item ebpcart__item--gift" data-ebpcart-item data-key="${encodeURIComponent(item.key)}" data-quantity="1">
        <a class="ebpcart__item-image" href="${escapeHtml(item.url || '#')}"><img src="${escapeHtml(this.resizeImage(image, 220))}" alt="${escapeHtml(item.product_title || '')}" loading="eager" width="220" height="220"></a>
        ${slot?.tier?.mark_gift !== false ? `<span class="ebpcart__gift-badge">${escapeHtml(state.rewards.texts?.gift_badge || 'CADOU')}</span>` : ''}
        <div class="ebpcart__item-body"><a class="ebpcart__item-title" href="${escapeHtml(item.url || '#')}">${escapeHtml(item.product_title || item.title || '')}</a><div class="ebpcart__item-options">${options}</div><small class="ebpcart__gift-source">${escapeHtml(slot?.tier?.message || `Cadou deblocat la pragul de ${this.formatMoney(Math.round(Number(slot?.tier?.value || 0) * 100))}`)}</small><div class="ebpcart__gift-actions"><button type="button" data-ebpc-reward-change data-slot-id="${escapeHtml(slotId)}" data-tier-id="${escapeHtml(slot?.tierId || '')}">${escapeHtml(state.rewards.texts?.change_gift || 'Schimba cadoul')}</button><button type="button" data-ebpc-reward-remove data-slot-id="${escapeHtml(slotId)}">${escapeHtml(state.rewards.texts?.remove_gift || 'Elimina')}</button></div></div>
        <div class="ebpcart__item-price"><strong>GRATUIT</strong>${originalLine > 0 ? `<del>${this.formatMoney(originalLine)}</del>` : ''}</div>
      </article>`;
    }
    optionRows(item) {
      let options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
      options = options.filter(option => option?.value && option.value !== 'Default Title');
      if (!options.length && item.variant_title && item.variant_title !== 'Default Title') {
        const parts = String(item.variant_title).split(' / ');
        options = parts.map((value, index) => ({ name:index === 0 ? this.config.texts.size : index === 1 ? this.config.texts.color : 'Varianta', value }));
      }
      const preferred = [];
      const rest = [];
      options.forEach(option => {
        const name = String(option.name || 'Varianta');
        if (/marime|size/i.test(name)) preferred.unshift({ ...option, displayName:this.config.texts.size });
        else if (/culoare|color/i.test(name)) preferred.push({ ...option, displayName:this.config.texts.color });
        else rest.push({ ...option, displayName:name });
      });
      return [...preferred, ...rest].map(option => `<span>${escapeHtml(option.displayName)}: <strong>${escapeHtml(option.value)}</strong></span>`).join('');
    }

    async removeGiftsInvalidatedByProjectedCart(key, quantity) {
      const currentCart = this.cart || await this.fetchCart();
      const currentLine = (currentCart.items || []).find(item => String(item.key) === String(key));
      if (!currentLine || this.isRewardGiftItem(currentLine) || Number(quantity) >= Number(currentLine.quantity || 0)) return;

      const currentQuantity = Math.max(1, Number(currentLine.quantity || 1));
      const ratio = Math.max(0, Number(quantity || 0)) / currentQuantity;
      const projectedItems = (currentCart.items || []).map(item => String(item.key) === String(key) ? {
        ...item,
        quantity:Number(quantity || 0),
        final_line_price:Math.round(Number(item.final_line_price || 0) * ratio),
        original_line_price:Math.round(Number(item.original_line_price || 0) * ratio)
      } : item);
      const projectedState = this.rewardState({ ...currentCart, items:projectedItems });
      if (!projectedState.invalidGiftKeys.length) return;

      const invalidKeys = new Set(projectedState.invalidGiftKeys.map(String));
      (currentCart.items || []).filter(item => invalidKeys.has(String(item.key))).forEach(item => {
        const slotId = String(item.properties?._eb_reward_slot_id || '');
        if (!slotId) return;
        try {
          localStorage.setItem(`ebpc-reward-${slotId}`, String(item.variant_id || item.id || ''));
        } catch (_) {}
      });

      const updates = Object.fromEntries(projectedState.invalidGiftKeys.map(giftKey => [giftKey, 0]));
      const response = await fetch(`${rootPath()}cart/update.js`, {
        method:'POST',
        credentials:'same-origin',
        headers:{ 'Content-Type':'application/json', Accept:'application/json' },
        body:JSON.stringify({ updates })
      });
      const updatedCart = await response.json();
      if (!response.ok) throw new Error(updatedCart.description || updatedCart.message || this.config.texts.error);
      this.cart = updatedCart;
      projectedState.invalidGiftKeys.forEach(giftKey => {
        this.track('reward_gift_auto_removed', { line_key:giftKey, reason:'projected_threshold' });
      });
    }
    async updateLine(itemNode, quantity, eventName) {
      if (!itemNode || itemNode.classList.contains('is-busy')) return;
      const key = decodeURIComponent(itemNode.dataset.key || '');
      if (!key) return;
      itemNode.classList.add('is-busy');
      itemNode.querySelectorAll('button').forEach(button => button.disabled = true);
      try {
        await this.removeGiftsInvalidatedByProjectedCart(key, quantity);
        const response = await fetch(`${rootPath()}cart/change.js`, {
          method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ id:key, quantity })
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || cart.message || this.config.texts.stock);
        this.cart = cart;
        await this.refreshRewardProgress(cart);
        this.renderCart();
        this.publishCartUpdate(quantity === 0 ? 'remove' : 'update', this.cart, key, quantity);
        this.track(eventName, { quantity, item_count:cart.item_count || 0 });
      } catch (error) {
        this.showStatus(error.message || this.config.texts.error, true);
        this.track('cart_error', { action:'change_line' });
        await this.refreshCart(false);
      }
    }

    getShippingState() {
      const shipping = this.config.shipping || {};
      const cart = this.cart || { items:[] };
      const rewards = this.rewardConfig();
      const freeTier = rewards.enabled
        ? (rewards.tiers || []).find(tier => tier.active !== false && tier.type === 'free_shipping' && Number(tier.value || 0) > 0)
        : null;
      const enabled = Boolean(shipping.enabled || freeTier);
      const threshold = Number(freeTier?.value || shipping.threshold || 0);
      const excluded = new Set(shipping.excluded_handles || []);
      const eligibleCents = (cart.items || []).reduce((sum, item) => {
        if (item.properties?._eb_reward_gift === true || item.properties?._eb_reward_gift === 'true') return sum;
        if (excluded.has(item.handle)) return sum;
        return sum + Number(shipping.calculate_after_discount ? item.final_line_price : item.original_line_price || item.final_line_price || 0);
      }, 0);
      const thresholdCents = Math.max(0, Math.round(threshold * 100));
      const reached = enabled && thresholdCents > 0 && eligibleCents >= thresholdCents;
      return {
        enabled,
        threshold,
        thresholdCents,
        eligibleCents,
        remaining:Math.max(0, thresholdCents - eligibleCents),
        reached,
        cost:Math.max(0, Number(shipping.cost || 0))
      };
    }

    renderShipping() {
      const state = this.getShippingState();
      const cart = this.cart || { items:[] };
      const rewards = this.rewardConfig();
      const rewardShipping = rewards.enabled && (rewards.tiers || []).some(tier => tier.active !== false && tier.type === 'free_shipping');
      if (rewardShipping || !state.enabled || state.thresholdCents <= 0 || !cart.items?.length) {
        this.shippingNode.hidden = true;
        return;
      }
      const progress = Math.min(100, state.eligibleCents / state.thresholdCents * 100);
      const text = state.reached ? this.config.texts.free_after : this.config.texts.free_before.replace('{remaining}', this.formatMoney(state.remaining));
      this.shippingNode.hidden = false;
      this.shippingNode.querySelector('[data-ebpcart-shipping-text]').textContent = text;
      this.shippingNode.querySelector('[data-ebpcart-shipping-values]').textContent = `${this.formatMoney(state.eligibleCents)} / ${this.formatMoney(state.thresholdCents)}`;
      const bar = this.shippingNode.querySelector('[data-ebpcart-progress]');
      bar.setAttribute('aria-valuenow', String(Math.round(progress)));
      bar.querySelector('span').style.width = `${progress}%`;
      if (state.reached && !this.thresholdWasReached) this.track('free_shipping_threshold_reached', { threshold:state.threshold });
      this.thresholdWasReached = state.reached;
    }

    deliveryState() {
      const config = this.config.delivery || DEFAULT_CONFIG.delivery;
      const attrs = this.cart?.attributes && typeof this.cart.attributes === 'object' ? this.cart.attributes : {};
      const storedSession = String(attrs['Qualuca - Easybox Session'] || '');
      const rawMethod = String(attrs['Qualuca - Metoda livrare'] || '').toLowerCase();
      const hasStoredEasybox = rawMethod === 'easybox' || Boolean(attrs['Qualuca - Easybox ID'] || attrs['Qualuca - Easybox']);
      const ownsEasybox = Boolean(storedSession && storedSession === this.sessionHash);
      const foreignEasybox = hasStoredEasybox && !ownsEasybox;
      const storedMethod = foreignEasybox ? '' : rawMethod;
      const easyboxReady = Boolean(config.easybox_enabled);
      const easyboxPickerReady = Boolean(
        easyboxReady &&
        String(config.client_id || '').trim() &&
        String(config.api_username || '').trim()
      );
      let method = storedMethod === 'easybox' && easyboxReady
        ? 'easybox'
        : storedMethod === 'standard'
          ? 'standard'
          : config.default_method === 'easybox' && easyboxReady
            ? 'easybox'
            : 'standard';
      if (!easyboxReady || !['standard', 'easybox'].includes(method)) method = 'standard';
      const locker = {
        id:foreignEasybox ? '' : String(attrs['Qualuca - Easybox ID'] || ''),
        type:foreignEasybox ? '0' : String(attrs['Qualuca - Easybox Tip'] || '0'),
        name:foreignEasybox ? '' : String(attrs['Qualuca - Easybox'] || ''),
        address:foreignEasybox ? '' : String(attrs['Qualuca - Adresa Easybox'] || ''),
        city:foreignEasybox ? '' : String(attrs['Qualuca - Oras Easybox'] || ''),
        county:foreignEasybox ? '' : String(attrs['Qualuca - Judet Easybox'] || ''),
        postalCode:foreignEasybox ? '' : String(attrs['Qualuca - Cod postal Easybox'] || '')
      };
      return { config, attrs, method, locker, hasLocker:Boolean(locker.id && locker.name), easyboxReady, easyboxPickerReady, foreignEasybox };
    }

    async updateCartAttributes(changes) {
      if (this.deliveryBusy) return null;
      this.deliveryBusy = true;
      this.deliveryNode?.classList.add('is-busy');
      try {
        const response = await fetch(`${rootPath()}cart/update.js`, {
          method:'POST',
          credentials:'same-origin',
          headers:{ 'Content-Type':'application/json', Accept:'application/json' },
          body:JSON.stringify({ attributes:{ ...(this.cart?.attributes || {}), ...changes } })
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || cart.message || this.config.texts.error);
        this.cart = cart;
        this.renderCart();
        this.publishCartUpdate('update', cart, 'delivery', 0);
        return cart;
      } catch (error) {
        this.setDeliveryStatus(error.message || this.config.texts.error, true);
        this.track('cart_error', { action:'delivery' });
        return null;
      } finally {
        this.deliveryBusy = false;
        this.deliveryNode?.classList.remove('is-busy');
        this.renderDelivery();
      }
    }

    async selectDeliveryMethod(method) {
      const state = this.deliveryState();
      const nextMethod = method === 'easybox' && state.easyboxReady ? 'easybox' : 'standard';
      const changes = {
        'Qualuca - Metoda livrare':nextMethod,
        'Qualuca - Easybox Session':nextMethod === 'easybox' ? this.sessionHash : ''
      };
      if (nextMethod === 'standard') {
        Object.assign(changes, {
          'Qualuca - Easybox ID':'',
          'Qualuca - Easybox Tip':'',
          'Qualuca - Easybox':'',
          'Qualuca - Adresa Easybox':'',
          'Qualuca - Oras Easybox':'',
          'Qualuca - Judet Easybox':'',
          'Qualuca - Cod postal Easybox':''
        });
      }
      await this.updateCartAttributes(changes);
      if (nextMethod === 'easybox') {
        if (this.deliveryDetails) this.deliveryDetails.open = true;
        const state = this.deliveryState();
        if (!state.hasLocker) this.dialog.querySelector('[data-ebpcart-easybox-choose]')?.focus({ preventScroll:true });
      }
    }

    setDeliveryStatus(message = '', isError = false) {
      if (!this.deliveryStatus) return;
      this.deliveryStatus.textContent = message;
      this.deliveryStatus.classList.toggle('is-error', Boolean(isError));
    }

    renderDelivery() {
      if (!this.deliveryNode) return;
      const state = this.deliveryState();
      const { config, method, locker, hasLocker, easyboxReady, easyboxPickerReady } = state;
      const visible = Boolean(config.enabled && this.cart?.items?.length);
      this.deliveryNode.hidden = !visible;
      if (!visible) return;
      const setText = (selector, value) => {
        const node = this.deliveryNode.querySelector(selector);
        if (node) node.textContent = value || '';
      };
      setText('[data-ebpcart-delivery-title]', config.title);
      setText('[data-ebpcart-delivery-current]', method === 'easybox' ? (hasLocker ? locker.name : config.easybox_label) : config.standard_label);
      setText('[data-ebpcart-delivery-standard-label]', config.standard_label);
      setText('[data-ebpcart-delivery-standard-description]', config.standard_description);
      setText('[data-ebpcart-delivery-easybox-label]', config.easybox_label);
      setText('[data-ebpcart-delivery-easybox-description]', config.easybox_description);
      this.deliveryNode.querySelectorAll('[data-ebpcart-delivery-method]').forEach(button => {
        const selected = button.dataset.ebpcartDeliveryMethod === method;
        button.setAttribute('aria-checked', String(selected));
        button.classList.toggle('is-selected', selected);
        button.disabled = this.deliveryBusy;
        if (button.dataset.ebpcartDeliveryMethod === 'easybox') button.hidden = !easyboxReady;
      });
      const panel = this.deliveryNode.querySelector('[data-ebpcart-easybox-panel]');
      const selected = this.deliveryNode.querySelector('[data-ebpcart-easybox-selected]');
      const choose = this.deliveryNode.querySelector('[data-ebpcart-easybox-choose]');
      if (panel) panel.hidden = method !== 'easybox' || !easyboxReady;
      if (selected) selected.hidden = method !== 'easybox' || !hasLocker;
      if (choose) {
        choose.hidden = method !== 'easybox' || !easyboxPickerReady;
        choose.disabled = this.deliveryBusy;
        choose.textContent = hasLocker ? config.change_locker : config.choose_locker;
      }
      if (hasLocker) {
        setText('[data-ebpcart-easybox-selected-label]', config.locker_selected);
        setText('[data-ebpcart-easybox-name]', locker.name);
        setText('[data-ebpcart-easybox-address]', [locker.address, locker.city, locker.county].filter(Boolean).join(', '));
        this.setDeliveryStatus('');
      } else if (method === 'easybox' && !easyboxPickerReady) {
        this.setDeliveryStatus(config.easybox_checkout_fallback || 'Vei alege lockerul Easybox la checkout.');
      } else if (method !== 'easybox') {
        this.setDeliveryStatus('');
      }
      this.configureWalletButtons();
    }

    loadSamedaySdk() {
      if (window.LockerPlugin) return Promise.resolve(window.LockerPlugin);
      if (this.samedaySdkPromise) return this.samedaySdkPromise;
      this.samedaySdkPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector('script[data-ebpcart-sameday-sdk]');
        const script = existing || document.createElement('script');
        const finish = () => window.LockerPlugin ? resolve(window.LockerPlugin) : reject(new Error('Selectorul Easybox nu a putut fi incarcat.'));
        script.addEventListener('load', finish, { once:true });
        script.addEventListener('error', () => reject(new Error('Selectorul Easybox nu a putut fi incarcat.')), { once:true });
        if (!existing) {
          script.src = 'https://cdn.sameday.ro/locker-plugin/lockerpluginsdk.js';
          script.async = true;
          script.dataset.ebpcartSamedaySdk = 'true';
          document.body.appendChild(script);
        }
      });
      return this.samedaySdkPromise;
    }

    async openEasyboxPicker() {
      const state = this.deliveryState();
      const config = state.config;
      if (!state.easyboxPickerReady) {
        this.setDeliveryStatus(config.sdk_not_configured, true);
        return;
      }
      const button = this.deliveryNode?.querySelector('[data-ebpcart-easybox-choose]');
      if (button) button.disabled = true;
      this.setDeliveryStatus('Se incarca harta Easybox...');
      try {
        await this.loadSamedaySdk();
        const options = {
          clientId:config.client_id,
          countryCode:config.country_code || 'RO',
          langCode:config.lang_code || 'ro',
          theme:config.theme || 'light',
          apiUsername:config.api_username,
          filters:[{ showLockers:true }, { showPudos:Boolean(config.show_pudos) }]
        };
        if (state.hasLocker && Number(state.locker.id)) {
          options.favLockerId = Number(state.locker.id);
          options.favType = Number(state.locker.type || 0);
        }
        const previousFrame = document.getElementById('locker-plugin-v2-iframe');
        if (previousFrame && previousFrame.parentElement !== document.body) {
          document.body.appendChild(previousFrame);
        }
        window.LockerPlugin.init(options);
        if (typeof window.LockerPlugin.reinitializePlugin === 'function') {
          window.LockerPlugin.reinitializePlugin(options);
        }
        this.samedayPlugin = window.LockerPlugin.getInstance();
        if (!this.samedaySubscribed) {
          this.samedayPlugin.subscribe(locker => this.saveEasybox(locker));
          this.samedaySubscribed = true;
        }
        if (!this.samedayCloseSubscribed && typeof this.samedayPlugin.subscribeToPluginClosed === 'function') {
          this.samedayPlugin.subscribeToPluginClosed(() => {
            if (!this.easyboxReturnToCart || this.easyboxSelectionInProgress || this.dialog.open) return;
            this.open(this.lastTrigger, true).finally(() => { this.easyboxReturnToCart = false; });
          });
          this.samedayCloseSubscribed = true;
        }
        this.easyboxReturnToCart = this.dialog.open;
        if (this.dialog.open) {
          this.dialog.close();
          document.body.classList.remove('ebpcart-open');
        }
        this.samedayPlugin.open();
        this.setDeliveryStatus('');
      } catch (error) {
        this.setDeliveryStatus(error.message || 'Selectorul Easybox nu a putut fi deschis.', true);
        if (this.easyboxReturnToCart && !this.dialog.open) await this.open(this.lastTrigger, true);
      } finally {
        if (button) button.disabled = false;
      }
    }

    async saveEasybox(locker) {
      if (!locker?.lockerId || !locker?.name) return;
      this.easyboxSelectionInProgress = true;
      this.samedayPlugin?.close?.();
      await this.updateCartAttributes({
        'Qualuca - Metoda livrare':'easybox',
        'Qualuca - Easybox Session':this.sessionHash,
        'Qualuca - Easybox ID':String(locker.lockerId),
        'Qualuca - Easybox Tip':String(locker.oohType || 0),
        'Qualuca - Easybox':String(locker.name || ''),
        'Qualuca - Adresa Easybox':String(locker.address || ''),
        'Qualuca - Oras Easybox':String(locker.city || ''),
        'Qualuca - Judet Easybox':String(locker.county || ''),
        'Qualuca - Cod postal Easybox':String(locker.postalCode || '')
      });
      this.setDeliveryStatus('Easybox-ul a fost salvat pentru aceasta comanda.');
      this.track('delivery_locker_selected', { locker_id:String(locker.lockerId), ooh_type:Number(locker.oohType || 0) });
      if (this.easyboxReturnToCart && !this.dialog.open) await this.open(this.lastTrigger, true);
      this.easyboxReturnToCart = false;
      this.easyboxSelectionInProgress = false;
    }

    async handleCheckout(event) {
      const state = this.deliveryState();
      if (state.foreignEasybox) {
        event.preventDefault();
        const target = this.discountCode
          ? `${rootPath()}discount/${encodeURIComponent(this.discountCode)}?redirect=${encodeURIComponent(rootPath() + 'checkout')}`
          : event.currentTarget?.href || `${rootPath()}checkout`;
        const cleared = await this.updateCartAttributes({
          'Qualuca - Metoda livrare':'standard',
          'Qualuca - Easybox Session':'',
          'Qualuca - Easybox ID':'',
          'Qualuca - Easybox Tip':'',
          'Qualuca - Easybox':'',
          'Qualuca - Adresa Easybox':'',
          'Qualuca - Oras Easybox':'',
          'Qualuca - Judet Easybox':'',
          'Qualuca - Cod postal Easybox':''
        });
        if (cleared) window.location.href = target;
        return;
      }
      if (state.config.enabled && state.method === 'easybox' && state.easyboxPickerReady && !state.hasLocker) {
        event.preventDefault();
        if (this.deliveryDetails) this.deliveryDetails.open = true;
        this.setDeliveryStatus(state.config.locker_required, true);
        this.dialog.querySelector('[data-ebpcart-easybox-choose]')?.focus({ preventScroll:true });
        return;
      }
      this.track('checkout_clicked', { item_count:this.cart?.item_count || 0, has_discount:Boolean(this.discountCode), delivery_method:state.method });
      if (!this.discountCode) return;
      event.preventDefault();
      window.location.href = `${rootPath()}discount/${encodeURIComponent(this.discountCode)}?redirect=${encodeURIComponent(rootPath() + 'checkout')}`;
    }
    getDeliveryPriceState() {
      const shippingState = this.getShippingState();
      const deliveryState = this.deliveryState();
      let cost = Number(shippingState.cost || 0);
      if (deliveryState.method === 'easybox') {
        cost = deliveryState.config.easybox_price_mode === 'fixed'
          ? Number(deliveryState.config.easybox_cost || 0)
          : Number(shippingState.cost || 0);
      }
      const cents = shippingState.reached ? 0 : Math.max(0, Math.round(cost * 100));
      return {
        cents,
        free:Boolean(shippingState.reached),
        label:shippingState.reached
          ? this.config.texts.shipping_free
          : cents > 0
            ? this.formatMoney(cents)
            : this.config.texts.shipping_calculated
      };
    }

    renderSummary() {
      const cart = this.cart || {};
      const paidTotal = (cart.items || []).reduce((sum, item) => this.isRewardGiftItem(item) ? sum : sum + Number(item.final_line_price || 0), 0);
      const deliveryPrice = this.getDeliveryPriceState();
      const subtotalNode = this.dialog.querySelector('[data-ebpcart-subtotal]');
      const totalNode = this.dialog.querySelector('[data-ebpcart-total]');
      const deliveryPriceNode = this.dialog.querySelector('[data-ebpcart-delivery-price]');
      if (subtotalNode) subtotalNode.textContent = this.formatMoney(paidTotal);
      if (deliveryPriceNode) {
        deliveryPriceNode.textContent = deliveryPrice.label;
        deliveryPriceNode.classList.toggle('is-free', deliveryPrice.free);
      }
      if (totalNode) totalNode.textContent = this.formatMoney(paidTotal + deliveryPrice.cents);
    }
    activeOffers() {
      if (!this.config.offers.enabled) return [];
      const now = new Date();
      const mobile = window.innerWidth < 750;
      const cartValue = Number(this.cart?.total_price || 0) / 100;
      return (this.config.offers.items || []).filter(offer => {
        if (!offer.active || cartValue < Number(offer.minimum_cart_value || 0)) return false;
        if (offer.device === 'mobile' && !mobile || offer.device === 'desktop' && mobile) return false;
        if (offer.start_date && now < new Date(`${offer.start_date}T00:00:00`)) return false;
        if (offer.end_date && now > new Date(`${offer.end_date}T23:59:59`)) return false;
        return true;
      }).sort((a, b) => Number(b.priority || 0) - Number(a.priority || 0));
    }

    renderOffers() {
      const offers = this.activeOffers();
      this.offersNode.hidden = !offers.length || !this.cart?.item_count;
      if (this.offersNode.hidden) return this.offersNode.replaceChildren();
      this.offersNode.innerHTML = offers.slice(0, 3).map(offer => {
        const link = offer.link || (offer.handle ? `${rootPath()}products/${offer.handle}` : `${rootPath()}collections/all`);
        return `<article class="ebpcart__offer ebpcart__offer--${escapeHtml(offer.type || 'strip')}">${offer.image ? `<img class="ebpcart__offer-image" src="${escapeHtml(offer.image)}" alt="" loading="lazy">` : ''}${offer.badge ? `<span class="ebpcart__offer-badge">${escapeHtml(offer.badge)}</span>` : ''}<div class="ebpcart__offer-copy"><strong>${escapeHtml(offer.title)}</strong>${offer.subtitle ? `<span>${escapeHtml(offer.subtitle)}</span>` : ''}</div><a href="${escapeHtml(link)}" data-ebpcart-offer-link data-offer-id="${escapeHtml(offer.id || '')}">${escapeHtml(offer.cta || 'Descopera')}</a></article>`;
      }).join('');
      offers.forEach(offer => this.track('upsell_viewed', { offer_id:offer.id || '' }));
    }

    async loadRecommendations() {
      const rec = this.config.recommendations;
      const showForEmpty = this.config.empty_cart.show_recommendations;
      if (!rec.enabled || (!this.cart?.item_count && !showForEmpty)) {
        this.recommendationsNode.hidden = true;
        return;
      }
      const inCart = new Set((this.cart?.items || []).map(item => item.handle));
      const maximum = window.innerWidth < 750 ? Number(rec.max_mobile || 8) : Number(rec.max_desktop || 8);
      const selected = (rec.items || []).filter(item => item.active && (!rec.hide_products_in_cart || !inCart.has(item.handle))).slice(0, maximum);
      if (!selected.length) {
        this.recommendationsNode.hidden = true;
        return;
      }
      const products = (await Promise.all(selected.map(item => this.fetchProduct(item.handle)))).filter(Boolean);
      if (!products.length) {
        this.recommendationsNode.hidden = true;
        return;
      }
      this.recommendationTrack.innerHTML = products.map(product => this.recommendationMarkup(product)).join('');
      this.recommendationsNode.hidden = false;
      this.dialog.querySelector('[data-ebpcart-recommendation-position]').textContent = `${products.length} produse`;
      products.forEach(product => this.track('recommendation_viewed', { handle:product.handle }));
    }

    async fetchProduct(handle) {
      if (this.productCache.has(handle)) return this.productCache.get(handle);
      try {
        const response = await fetch(`${rootPath()}products/${encodeURIComponent(handle)}.js`, { headers:{ Accept:'application/json' }, credentials:'same-origin' });
        if (!response.ok) return null;
        const product = await response.json();
        this.productCache.set(handle, product);
        return product;
      } catch (_) { return null; }
    }

    recommendationMarkup(product) {
      const available = (product.variants || []).filter(variant => variant.available);
      const selected = available[0] || product.variants?.[0];
      const image = product.featured_image || product.images?.[0] || '';
      const compareAt = Number(selected?.compare_at_price || 0);
      const price = Number(selected?.price || 0);
      const productUrl = `${rootPath()}products/${escapeHtml(product.handle)}`;
      const addLabel = 'Adaugă în coș';
      return `<article class="ebpcart__recommendation" data-handle="${escapeHtml(product.handle)}"><a href="${productUrl}" class="ebpcart__recommendation-image" data-ebpcart-recommendation-link data-handle="${escapeHtml(product.handle)}"><img src="${escapeHtml(this.resizeImage(image, 260))}" alt="${escapeHtml(product.title)}" loading="lazy" width="260" height="220"></a><span class="ebpcart__recommendation-body"><a href="${productUrl}" class="ebpcart__recommendation-title" data-ebpcart-recommendation-link data-handle="${escapeHtml(product.handle)}">${escapeHtml(product.title)}</a><span class="ebpcart__recommendation-price"><strong>${this.formatMoney(price)}</strong>${compareAt > price ? `<del>${this.formatMoney(compareAt)}</del>` : ''}</span><button type="button" class="ebpcart__recommendation-add" data-ebpcart-recommendation-add data-variant-id="${Number(selected?.id || 0)}" aria-label="${escapeHtml(addLabel)}: ${escapeHtml(product.title)}">${escapeHtml(addLabel)}</button></span></article>`;
    }
    async addRecommendation(button) {
      if (button.disabled) return;
      const card = button.closest('.ebpcart__recommendation');
      const select = card?.querySelector('select');
      const variantId = Number(select?.value || button.dataset.variantId || 0);
      if (!variantId) return;
      button.disabled = true;
      const original = button.textContent;
      button.textContent = '...';
      try {
        const response = await fetch(`${rootPath()}cart/add.js`, { method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ items:[{ id:variantId, quantity:1 }] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.config.texts.stock);
        this.cart = await this.fetchCart();
        await this.refreshRewardProgress(this.cart);
        this.renderCart();
        this.publishCartUpdate('add', this.cart, String(variantId), 1);
        this.showStatus(this.config.texts.added, false);
        this.track('recommendation_added', { handle:card?.dataset.handle || '', variant_id:variantId });
      } catch (error) {
        this.showStatus(error.message || this.config.texts.error, true);
        this.track('cart_error', { action:'recommendation_add' });
      } finally {
        button.disabled = false;
        button.textContent = original;
      }
    }

    rewardConfig() {
      const rewards = this.config?.rewards || DEFAULT_CONFIG.rewards;
      const tiers = (rewards.tiers || []).filter(tier => tier?.active !== false && Number(tier?.value || 0) > 0).sort((a, b) => Number(a.value) - Number(b.value));
      return { ...rewards, tiers };
    }

    normalizeResourceId(value) {
      return String(value ?? '').replace(/^.*\//, '');
    }

    isRewardGiftItem(item) {
      return String(item?.properties?._eb_reward_gift || '').toLowerCase() === 'true';
    }

    eligibleRewardSubtotal(cart = this.cart) {
      const rewards = this.rewardConfig();
      const excluded = new Set([...(rewards.excluded_product_ids || []), ...(rewards.resolved_excluded_product_ids || [])].map(value => this.normalizeResourceId(value)));
      return (cart?.items || []).reduce((sum, item) => {
        if (this.isRewardGiftItem(item)) return sum;
        if (excluded.has(this.normalizeResourceId(item.product_id))) return sum;
        return sum + Number(item.final_line_price || 0);
      }, 0);
    }

    rewardState(cart = this.cart) {
      const rewards = this.rewardConfig();
      const eligibleSubtotal = this.eligibleRewardSubtotal(cart);
      const reached = rewards.tiers.filter(tier => eligibleSubtotal >= Math.round(Number(tier.value || 0) * 100));
      const unlocked = rewards.cumulative === false ? reached.slice(-1) : reached;
      const unlockedIds = new Set(unlocked.map(tier => String(tier.id)));
      const nextTier = rewards.tiers.find(tier => !unlockedIds.has(String(tier.id))) || null;
      const slots = [];
      let giftOrdinal = 0;
      unlocked.filter(tier => tier.type === 'gift').forEach(tier => {
        const quantity = Math.max(1, Number(tier.gift_quantity || 1));
        for (let index = 0; index < quantity; index += 1) {
          giftOrdinal += 1;
          slots.push({ id:`${tier.id}-${index + 1}`, tierId:String(tier.id), tier, ordinal:giftOrdinal, item:null });
        }
      });
      const slotMap = new Map(slots.map(slot => [slot.id, slot]));
      const invalidGiftKeys = [];
      const usedProducts = new Set();
      (cart?.items || []).filter(item => this.isRewardGiftItem(item)).forEach(item => {
        const campaignId = String(item.properties?._eb_reward_campaign_id || '');
        const tierId = String(item.properties?._eb_reward_tier_id || '');
        const slotId = String(item.properties?._eb_reward_slot_id || '');
        const slot = slotMap.get(slotId);
        const variantId = this.normalizeResourceId(item.variant_id || item.id);
        const productId = this.normalizeResourceId(item.product_id);
        const allowed = new Set((slot?.tier?.eligible_variant_ids || []).map(value => this.normalizeResourceId(value)));
        const duplicateBlocked = slot?.tier?.allow_same_product === false && productId && usedProducts.has(productId);
        const valid = campaignId === String(rewards.campaign_id) && slot && slot.tierId === tierId && Number(item.quantity || 0) === 1 && allowed.has(variantId) && !duplicateBlocked && !slot.item;
        if (!valid) {
          if (item.key) invalidGiftKeys.push(String(item.key));
          return;
        }
        slot.item = item;
        if (productId) usedProducts.add(productId);
      });
      const maxTierCents = rewards.tiers.length ? Math.round(Number(rewards.tiers.at(-1).value || 0) * 100) : 0;
      const progress = maxTierCents > 0 ? Math.min(100, eligibleSubtotal / maxTierCents * 100) : 0;
      const freeShipping = unlocked.filter(tier => tier.type === 'free_shipping').at(-1) || null;
      return { rewards, eligibleSubtotal, unlocked, unlockedIds, nextTier, slots, invalidGiftKeys, maxTierCents, progress, freeShipping };
    }

    async refreshRewardProgress(cart = this.cart) {
      if (this.rewardSyncPromise) return this.rewardSyncPromise;
      this.rewardSyncPromise = (async () => {
        let state = this.rewardState(cart);
        if (!state.rewards.enabled) {
          const staleGiftKeys = (cart?.items || []).filter(item => this.isRewardGiftItem(item) && item.key).map(item => String(item.key));
          if (staleGiftKeys.length) {
            const updates = Object.fromEntries(staleGiftKeys.map(key => [key, 0]));
            const response = await fetch(`${rootPath()}cart/update.js`, {
              method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ updates })
            });
            const updatedCart = await response.json();
            if (!response.ok) throw new Error(updatedCart.description || updatedCart.message || this.config.texts.error);
            this.cart = updatedCart;
            staleGiftKeys.forEach(key => this.track('reward_gift_auto_removed', { line_key:key, reason:'campaign_disabled' }));
            state = this.rewardState(updatedCart);
          }
          this.renderRewards(state);
          return state;
        }
        if (state.invalidGiftKeys.length) {
          const updates = Object.fromEntries(state.invalidGiftKeys.map(key => [key, 0]));
          const response = await fetch(`${rootPath()}cart/update.js`, {
            method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ updates })
          });
          const updatedCart = await response.json();
          if (!response.ok) throw new Error(updatedCart.description || updatedCart.message || this.config.texts.error);
          this.cart = updatedCart;
          state.invalidGiftKeys.forEach(key => this.track('reward_gift_auto_removed', { line_key:key }));
          state = this.rewardState(updatedCart);
        }
        state.unlocked.forEach(tier => {
          const key = String(tier.id);
          if (this.rewardUnlockedSeen.has(key)) return;
          this.rewardUnlockedSeen.add(key);
          this.track(tier.type === 'free_shipping' ? 'reward_free_shipping_unlocked' : 'reward_tier_unlocked', { tier_id:key, threshold:Number(tier.value || 0), type:tier.type });
        });
        this.renderRewards(state);
        return state;
      })().catch(error => {
        console.warn('[Qualuca cart] Reward refresh failed.', error);
        this.showStatus(error.message || this.config.texts.error, true);
        return this.rewardState(this.cart);
      }).finally(() => { this.rewardSyncPromise = null; });
      return this.rewardSyncPromise;
    }

    rewardMessage(state) {
      const texts = state.rewards.texts || {};
      if (!this.cart?.items?.length) return state.rewards.empty_text || DEFAULT_CONFIG.rewards.empty_text;
      const hasGiftTier = state.rewards.tiers.some(tier => tier.type === 'gift');
      if (!state.nextTier && !hasGiftTier && state.freeShipping) return this.config.texts.free_after || 'Ai obtinut livrare gratuita!';
      if (!state.nextTier) return state.rewards.all_unlocked_text || texts.all_unlocked || DEFAULT_CONFIG.rewards.all_unlocked_text;
      const threshold = Math.round(Number(state.nextTier.value || 0) * 100);
      const amount = this.formatMoney(Math.max(0, threshold - state.eligibleSubtotal));
      const unlockedGifts = state.slots.length;
      let template;
      if (state.nextTier.type === 'free_shipping') template = texts.shipping_before;
      else if (state.nextTier.type === 'gift' && unlockedGifts > 0) template = texts.below_second;
      else template = texts.below_first;
      const nextMessage = String(template || 'Mai adauga {{amount}} pentru urmatoarea recompensa.').replace(/\{\{amount\}\}|\{amount\}/g, amount);
      if (unlockedGifts === 1 && state.nextTier) return `${texts.first_unlocked || 'Ai deblocat primul cadou!'} ${nextMessage}`;
      if (unlockedGifts >= 2 && state.nextTier) return `${texts.second_unlocked || 'Ai deblocat doua cadouri!'} ${nextMessage}`;
      return nextMessage;
    }

    rewardIcon(name, className = '') {
      const paths = {
        gift:'<path d="M4 10h16v10H4zM12 10v10M3 7h18v3H3zM12 7c-2.8 0-5-1.1-5-2.5S8.3 2 9.8 2C11.4 2 12 4.3 12 7Zm0 0c2.8 0 5-1.1 5-2.5S15.7 2 14.2 2C12.6 2 12 4.3 12 7Z"></path>',
        truck:'<path d="M3 6h11v10H3zM14 9h4l3 3v4h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"></path>',
        percent:'<path d="m5 19 14-14M7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"></path>',
        discount:'<path d="M20 13 13 20 4 11V4h7l9 9ZM8 8h.01"></path>',
        star:'<path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-2.9-5.6 2.9 1.1-6.2L3 9.6l6.2-.9L12 3Z"></path>',
        sock:'<path d="M8 3h7v8c0 1.5 1.5 2.2 3.2 3.1 2 1.1 2.2 4 .3 5.3-3 2-8.3 2-11.2.1-2.1-1.4-1.8-4.8.6-5.8L10 12V3"></path>',
        crown:'<path d="m3 7 4 4 5-7 5 7 4-4-2 12H5L3 7Zm3 15h12"></path>',
        sparkles:'<path d="m12 3 1.2 3.8L17 8l-3.8 1.2L12 13l-1.2-3.8L7 8l3.8-1.2L12 3Zm7 10 .8 2.2L22 16l-2.2.8L19 19l-.8-2.2L16 16l2.2-.8L19 13ZM5 13l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3Z"></path>'
      };
      return `<svg class="${escapeHtml(className)}" viewBox="0 0 24 24" aria-hidden="true">${paths[name] || paths.gift}</svg>`;
    }

    renderRewards(state = this.rewardState(this.cart)) {
      this.syncRewardNodes();
      const rewards = state.rewards;
      const targets = [
        { node:this.rewardsDrawer, visible:rewards.enabled && rewards.show_drawer !== false },
        { node:this.rewardsPage, visible:rewards.enabled && rewards.show_cart_page !== false }
      ];
      targets.forEach(({ node, visible }) => {
        if (!node) return;
        node.hidden = !visible;
        if (!visible) { node.replaceChildren(); return; }
        const appearance = rewards.appearance || {};
        const vars = {
          '--ebpcr-bg':appearance.background,'--ebpcr-progress':appearance.progress,'--ebpcr-unlocked':appearance.unlocked,
          '--ebpcr-locked':appearance.locked,'--ebpcr-text':appearance.text,'--ebpcr-button':appearance.button,
          '--ebpcr-radius':`${Number(appearance.radius || 8)}px`,'--ebpcr-spacing':`${Number(appearance.spacing || 12)}px`,
          '--ebpcr-icon-size':`${Number(appearance.icon_size || 22)}px`
        };
        Object.entries(vars).forEach(([key, value]) => node.style.setProperty(key, value || ''));
        node.classList.toggle('ebpc-rewards--shipping-only', rewards.tiers.length === 1 && rewards.tiers[0]?.type === 'free_shipping');
        node.innerHTML = this.rewardsMarkup(state);
      });
      const hasRewardShipping = rewards.enabled && rewards.tiers.some(tier => tier.type === 'free_shipping');
      if (hasRewardShipping && this.shippingNode) this.shippingNode.hidden = true;
    }

    rewardsMarkup(state) {
      const rewards = state.rewards;
      const tiers = rewards.tiers || [];
      const maximum = Math.max(1, state.maxTierCents);
      const markerInset = tiers.length > 1 ? 11 : 0;
      const tierPositions = tiers.map((tier, index) => tiers.length <= 1
        ? 100
        : markerInset + ((100 - markerInset * 2) * index / (tiers.length - 1)));
      const tierCents = tiers.map(tier => Math.round(Number(tier.value || 0) * 100));
      const visualProgress = (() => {
        if (!tiers.length) return 0;
        const amount = Math.max(0, Number(state.eligibleSubtotal || 0));
        if (amount <= tierCents[0]) return tierCents[0] > 0 ? tierPositions[0] * amount / tierCents[0] : 0;
        for (let index = 1; index < tierCents.length; index += 1) {
          if (amount <= tierCents[index]) {
            const range = Math.max(1, tierCents[index] - tierCents[index - 1]);
            const ratio = (amount - tierCents[index - 1]) / range;
            return tierPositions[index - 1] + (tierPositions[index] - tierPositions[index - 1]) * ratio;
          }
        }
        return 100;
      })();
      const milestones = tiers.map((tier, index) => {
        const unlocked = state.unlockedIds.has(String(tier.id));
        const next = state.nextTier && String(state.nextTier.id) === String(tier.id);
        const left = tierPositions[index];
        const stateLabel = unlocked ? (rewards.texts?.unlocked_label || 'Deblocat') : (rewards.texts?.locked_label || 'Blocat');
        const tierTitle = tier.type === 'free_shipping' ? 'Livrare gratuit\u0103' : (tier.title || '');
        const milestoneIcon = tier.type === 'free_shipping'
          ? this.rewardIcon('truck')
          : (unlocked ? '<span aria-hidden="true">&#10003;</span>' : this.rewardIcon(tier.icon));
        return `<div class="ebpc-rewards__milestone${unlocked ? ' is-unlocked' : ''}${next ? ' is-next' : ''}" style="left:${left}%" aria-label="${escapeHtml(tierTitle)}: ${escapeHtml(stateLabel)}">
          <strong class="ebpc-rewards__milestone-value">${escapeHtml(this.formatMoney(Math.round(Number(tier.value || 0) * 100)))}</strong>
          <span class="ebpc-rewards__dot">${milestoneIcon}</span>
          <small>${escapeHtml(tierTitle)}</small>
          <em>${escapeHtml(stateLabel)}</em>
        </div>`;
      }).join('');
      const slots = this.giftSlotsMarkup(state);
      const hasGiftTier = tiers.some(tier => tier.type === 'gift');
      const shippingOnly = tiers.length === 1 && tiers[0]?.type === 'free_shipping';
      const moduleTitle = hasGiftTier ? (rewards.title || '') : 'Livrare gratuita Qualuca';
      const moduleDescription = hasGiftTier ? rewards.description : 'Livrarea gratuita se deblocheaza automat la pragul setat.';
      return `${shippingOnly ? '' : `<div class="ebpc-rewards__header"><h3>${escapeHtml(moduleTitle)}</h3>${moduleDescription ? `<p>${escapeHtml(moduleDescription)}</p>` : ''}</div>`}
        <p class="ebpc-rewards__message" aria-live="polite">${escapeHtml(this.rewardMessage(state))}</p>
        ${tiers.length ? `<div class="ebpc-rewards__timeline${shippingOnly ? ' is-single-tier' : ''}" aria-label="Progres recompense"><div class="ebpc-rewards__timeline-inner"><div class="ebpc-rewards__track" role="progressbar" aria-valuemin="0" aria-valuemax="${maximum}" aria-valuenow="${Math.min(maximum, state.eligibleSubtotal)}"><span style="width:${visualProgress}%"></span></div>${milestones}</div></div>` : ''}
        ${slots}`;
    }

    giftSlotsMarkup(state) {
      if (!state.slots.length) return '';
      const texts = state.rewards.texts || {};
      return `<div class="ebpc-rewards__slots">${state.slots.map(slot => {
        const item = slot.item;
        if (!item) return `<article class="ebpc-rewards__slot"><div><span>Cadoul ${slot.ordinal}</span><strong>${escapeHtml(slot.tier.title || 'Cadou Qualuca')}</strong></div><button type="button" data-ebpc-reward-choose data-slot-id="${escapeHtml(slot.id)}" data-tier-id="${escapeHtml(slot.tierId)}">${escapeHtml(slot.tier.button_text || texts.choose_gift || 'Alege cadoul')}</button></article>`;
        const threshold = this.formatMoney(Math.round(Number(slot.tier.value || 0) * 100));
        return `<article class="ebpc-rewards__slot ebpc-rewards__slot--confirmed" aria-live="polite"><span class="ebpc-rewards__slot-check" aria-hidden="true">&#10003;</span><strong>Cadou deblocat la pragul de ${escapeHtml(threshold)}</strong></article>`;
      }).join('')}</div>`;
    }

    async openRewardPicker(slotId, tierId) {
      if (!slotId || !tierId || !this.rewardPicker || this.rewardBusy) return;
      const state = this.rewardState(this.cart);
      const slot = state.slots.find(item => item.id === slotId && item.tierId === tierId);
      if (!slot) return;
      this.rewardSlot = slot;
      this.rewardPicker.querySelector('[data-ebpc-reward-picker-status]').textContent = '';
      this.rewardPicker.querySelector('#ebpc-reward-picker-title').textContent = state.rewards.texts?.gift_modal_title || 'Alege produsul cadou';
      this.rewardPickerBody.innerHTML = '<p class="ebpc-reward-picker__loading">Se incarca produsele disponibile...</p>';
      if (!this.rewardPicker.open) this.rewardPicker.showModal();
      document.body.classList.add('ebpc-reward-picker-open');
      this.track('reward_gift_picker_opened', { tier_id:tierId, slot_id:slotId });
      const products = (await Promise.all((slot.tier.eligible_products || []).map(async configured => {
        const live = configured.handle ? await this.fetchProduct(configured.handle) : null;
        return this.rewardPickerProduct(configured, live, slot.tier, slot.id);
      }))).filter(Boolean);
      this.rewardPickerBody.innerHTML = products.length ? `<div class="ebpc-reward-picker__grid">${products.join('')}</div>` : '<p class="ebpc-reward-picker__empty">Nu exista momentan variante cadou in stoc.</p>';
      requestAnimationFrame(() => this.rewardPicker.querySelector('select,button')?.focus());
    }

    rewardPickerProduct(configured, live, tier, slotId) {
      const allowed = new Set((tier.eligible_variant_ids || []).map(value => this.normalizeResourceId(value)));
      const variants = (live?.variants || configured.variants || []).filter(variant => {
        const id = this.normalizeResourceId(variant.id || variant.numeric_id);
        const available = variant.available !== false && Number(variant.inventory_quantity ?? 1) !== 0;
        return allowed.has(id) && (tier.hide_oos === false || available);
      });
      if (!variants.length) return '';
      const image = configured.image || live?.featured_image || live?.images?.[0] || variants[0]?.featured_image?.src || variants[0]?.image || '';
      let rememberedVariant = '';
      try { rememberedVariant = String(localStorage.getItem(`ebpc-reward-${slotId}`) || ''); } catch (_) {}
      const options = variants.map(variant => {
        const id = this.normalizeResourceId(variant.id || variant.numeric_id);
        const disabled = variant.available === false || Number(variant.inventory_quantity ?? 1) === 0;
        return `<option value="${escapeHtml(id)}"${disabled ? ' disabled' : ''}${id === rememberedVariant ? ' selected' : ''}>${escapeHtml(variant.title || 'Varianta')}</option>`;
      }).join('');
      const variantControl = tier.allow_variant_choice === false
        ? `<input type="hidden" data-ebpc-reward-variant value="${escapeHtml(this.normalizeResourceId(variants[0].id || variants[0].numeric_id))}">`
        : `<label><span>${escapeHtml(this.config.texts.size || 'Marime')}</span><select data-ebpc-reward-variant aria-label="Alege varianta pentru ${escapeHtml(configured.title || live?.title || '')}">${options}</select></label>`;
      return `<article class="ebpc-reward-picker__product"><img src="${escapeHtml(this.resizeImage(image, 320))}" alt="${escapeHtml(configured.title || live?.title || '')}" width="260" height="220" loading="lazy"><h3>${escapeHtml(configured.title || live?.title || '')}</h3>${variantControl}<button type="button" data-ebpc-reward-add>${escapeHtml(tier.button_text || this.rewardConfig().texts?.choose_free || 'Alege gratuit')}</button></article>`;
    }

    async addRewardGift(button) {
      if (this.rewardBusy || !this.rewardSlot) return;
      const select = button.closest('.ebpc-reward-picker__product')?.querySelector('[data-ebpc-reward-variant]');
      const variantId = Number(select?.value || 0);
      if (!variantId) return;
      const state = this.rewardState(this.cart);
      const slot = state.slots.find(item => item.id === this.rewardSlot.id);
      if (!slot) return this.closeRewardPicker();
      const selectedProduct = (slot.tier.eligible_products || []).find(product =>
        (product.variants || []).some(variant => this.normalizeResourceId(variant.id || variant.numeric_id) === String(variantId))
      );
      const selectedProductId = this.normalizeResourceId(selectedProduct?.product_id);
      if (slot.tier.allow_same_product === false && selectedProductId && state.slots.some(item =>
        item.id !== slot.id && this.normalizeResourceId(item.item?.product_id) === selectedProductId
      )) {
        this.rewardPicker.querySelector('[data-ebpc-reward-picker-status]').textContent = 'Alege un alt produs pentru acest cadou.';
        return;
      }
      this.rewardBusy = true;
      button.disabled = true;
      try {
        const paidLineQuantities = new Map(
          (this.cart?.items || [])
            .filter(item => !this.isRewardGiftItem(item) && item?.key)
            .map(item => [String(item.key), Number(item.quantity || 0)])
        );
        if (slot.item?.key) {
          const removeResponse = await fetch(`${rootPath()}cart/change.js`, { method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ id:slot.item.key, quantity:0 }) });
          if (!removeResponse.ok) throw new Error(this.config.texts.error);
        }
        const properties = {
          _eb_reward_gift:'true', _eb_reward_tier_id:slot.tierId, _eb_reward_slot_id:slot.id,
          _eb_reward_campaign_id:String(state.rewards.campaign_id || 'qualuca-cart-rewards')
        };
        const response = await fetch(`${rootPath()}cart/add.js`, { method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ items:[{ id:variantId, quantity:1, properties }] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.config.texts.stock);
        this.cart = await this.fetchCart();
        const changedPaidLines = (this.cart?.items || []).filter(item => {
          const previousQuantity = paidLineQuantities.get(String(item.key || ''));
          return previousQuantity !== undefined && Number(item.quantity || 0) !== previousQuantity;
        });
        if (changedPaidLines.length) {
          const updates = Object.fromEntries(changedPaidLines.map(item => [
            String(item.key),
            paidLineQuantities.get(String(item.key))
          ]));
          console.warn('[Qualuca cart] Restoring paid line quantities after reward selection.', updates);
          const restoreResponse = await fetch(`${rootPath()}cart/update.js`, {
            method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ updates })
          });
          const restoredCart = await restoreResponse.json();
          if (!restoreResponse.ok) throw new Error(restoredCart.description || restoredCart.message || this.config.texts.error);
          this.cart = restoredCart;
        }
        await this.refreshRewardProgress(this.cart);
        this.renderCart();
        this.publishCartUpdate('add', this.cart, String(variantId), 1);
        this.track(slot.item ? 'reward_gift_changed' : 'reward_gift_selected', { tier_id:slot.tierId, slot_id:slot.id, variant_id:variantId });
        try { localStorage.setItem(`ebpc-reward-${slot.id}`, String(variantId)); } catch (_) {}
        this.closeRewardPicker();
      } catch (error) {
        const status = this.rewardPicker.querySelector('[data-ebpc-reward-picker-status]');
        if (status) status.textContent = error.message || this.config.texts.error;
        this.track('cart_error', { action:'reward_gift_add' });
      } finally {
        this.rewardBusy = false;
        button.disabled = false;
      }
    }

    async removeRewardGift(slotId) {
      if (this.rewardBusy || !slotId) return;
      const state = this.rewardState(this.cart);
      const slot = state.slots.find(item => item.id === slotId);
      if (!slot?.item?.key) return;
      this.rewardBusy = true;
      try {
        const response = await fetch(`${rootPath()}cart/change.js`, { method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ id:slot.item.key, quantity:0 }) });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || cart.message || this.config.texts.error);
        this.cart = cart;
        await this.refreshRewardProgress(cart);
        this.renderCart();
        this.publishCartUpdate('remove', cart, slot.item.key, 0);
        this.track('reward_gift_removed', { tier_id:slot.tierId, slot_id:slot.id });
      } catch (error) {
        this.showStatus(error.message || this.config.texts.error, true);
      } finally { this.rewardBusy = false; }
    }

    closeRewardPicker() {
      if (!this.rewardPicker?.open) return;
      this.rewardPicker.close();
      document.body.classList.remove('ebpc-reward-picker-open');
      const trigger = document.querySelector(`[data-slot-id="${CSS.escape(this.rewardSlot?.id || '')}"]`);
      this.rewardSlot = null;
      trigger?.focus({ preventScroll:true });
    }

    trapRewardPickerFocus(event) {
      if (event.key === 'Escape') { event.preventDefault(); this.closeRewardPicker(); return; }
      if (event.key !== 'Tab' || !this.rewardPicker?.open) return;
      const focusable = [...this.rewardPicker.querySelectorAll('button:not([disabled]),select:not([disabled]),a[href],input:not([disabled])')].filter(node => node.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    publishCartUpdate(action, cart, id, quantity) {
      const summary = {
        id:cart.token || 'ajax-cart', totalQuantity:Number(cart.item_count || 0),
        cost:{ totalAmount:{ amount:(Number(cart.total_price || 0) / 100).toFixed(2), currencyCode:cart.currency || this.config.shipping.currency || 'RON' } },
        lines:(cart.items || []).map(item => ({ id:item.key || String(item.id), quantity:Number(item.quantity || 0), cost:{ totalAmount:{ amount:(Number(item.final_line_price || 0) / 100).toFixed(2), currencyCode:cart.currency || 'RON' } } })),
        discountCodes:(cart.discount_codes || []).map(discount => ({ code:discount.code, applicable:Boolean(discount.applicable) }))
      };
      const event = new Event('shopify:cart:lines-update', { bubbles:true });
      Object.defineProperties(event, {
        action:{ value:action }, context:{ value:'cart' }, lines:{ value:[{ merchandiseId:String(id), quantity }] }, qualucaCartSource:{ value:true },
        promise:{ value:Promise.resolve({ cart:summary, detail:{ items:cart.items || [], itemCount:Number(cart.item_count || 0), source:'qualuca-cart', sourceId:'qualuca-cart-dialog', didError:false } }) }
      });
      document.dispatchEvent(event);
      this.scheduleRewardRender();
    }

    showStatus(message, error = false) {
      clearTimeout(this.statusTimer);
      this.statusNode.textContent = message;
      this.statusNode.classList.toggle('is-error', error);
      this.statusTimer = window.setTimeout(() => { this.statusNode.textContent = ''; this.statusNode.classList.remove('is-error'); }, 3800);
    }

    formatMoney(cents) {
      const currency = this.cart?.currency || this.config.shipping.currency || window.Shopify?.currency?.active || 'RON';
      try { return new Intl.NumberFormat('ro-RO', { style:'currency', currency, maximumFractionDigits:2 }).format(Number(cents || 0) / 100); }
      catch (_) { return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`; }
    }

    resizeImage(url, width) {
      if (!url) return '';
      try {
        const parsed = new URL(url, window.location.origin);
        if (/cdn\.shopify\.com|shopifycdn\.net/.test(parsed.hostname)) parsed.searchParams.set('width', String(width));
        return parsed.toString();
      } catch (_) { return url; }
    }

    getSessionHash() {
      const key = 'qualuca-cart-session';
      let value = sessionStorage.getItem(key);
      if (!value || !/^[a-f0-9]{64}$/.test(value)) {
        const bytes = new Uint8Array(32);
        crypto.getRandomValues(bytes);
        value = [...bytes].map(byte => byte.toString(16).padStart(2, '0')).join('');
        sessionStorage.setItem(key, value);
      }
      return value;
    }

    track(event, metadata = {}) {
      if (!this.config.tracking?.enabled || !this.configEndpoint) return;
      const payload = JSON.stringify({ event, session_hash:this.sessionHash, cart_value:Number(this.cart?.total_price || 0) / 100, metadata });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(this.configEndpoint, new Blob([payload], { type:'text/plain;charset=UTF-8' }));
      } else {
        fetch(this.configEndpoint, { method:'POST', mode:'cors', keepalive:true, credentials:'omit', headers:{ 'Content-Type':'text/plain;charset=UTF-8' }, body:payload }).catch(() => {});
      }
      window.dataLayer?.push({ event:`qualuca_${event}`, ...metadata });
    }
  }

  const initialize = () => {
    const dialog = document.querySelector('[data-ebpcart]');
    if (!dialog || dialog.ebPrimeCart) return;
    dialog.ebPrimeCart = new EbPrimeCartDrawer(dialog);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once:true });
  else initialize();
})();





